/* Two-column mega menu: switches the right-hand panel when a main category is hovered or focused. */
(function () {
  if (window.__mmpPanelsInit) return;
  window.__mmpPanelsInit = true;

  function activate(tab) {
    var menu = tab.closest('.mega-menu--panels');
    if (!menu) return;
    var id = tab.getAttribute('data-mmp-panel');
    menu.querySelectorAll('.mmp__tab').forEach(function (t) {
      t.classList.toggle('is-active', t === tab);
    });
    menu.querySelectorAll('.mmp__panel').forEach(function (p) {
      p.classList.toggle('is-active', p.id === id);
    });
  }

  function tabFrom(event) {
    return event.target && event.target.closest ? event.target.closest('.mmp__tab') : null;
  }

  document.addEventListener('mouseover', function (event) {
    var tab = tabFrom(event);
    if (tab) activate(tab);
  });

  document.addEventListener('focusin', function (event) {
    var tab = tabFrom(event);
    if (tab) activate(tab);
  });

  /* Every time the menu opens, start on the first category (Fiction). */
  document.addEventListener('toggle', function (event) {
    var menu = event.target;
    if (menu && menu.classList && menu.classList.contains('mega-menu--panels') && menu.open) {
      var first = menu.querySelector('.mmp__tab');
      if (first) activate(first);
    }
  }, true);
})();
